import { AuthMethod, creditAssessment, } from "@wayke-se/ecom";
export default (caseId, callback) => {
    const request = {
        caseId,
        method: AuthMethod.SameDevice,
    };
    creditAssessment.signCase(request).then(callback).catch(callback);
};
